import { useParams } from 'react-router-dom';

export function DraftReview() {
  const { draftId } = useParams<{ draftId: string }>();
  return (
    <div className="container mx-auto max-w-7xl px-6 py-10">
      <header>
        <p className="text-xs font-mono text-muted-foreground">/queue/{draftId}</p>
        <h1 className="mt-1 text-3xl font-bold tracking-tight">Draft review</h1>
        <p className="mt-2 text-muted-foreground">
          Full editor + member context sidebar. Wires in W3.
        </p>
      </header>

      <div className="mt-8 grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2 rounded-xl border border-border bg-card p-6 shadow-sm">
          <p className="text-sm font-semibold uppercase tracking-widest text-muted-foreground">
            Editor
          </p>
          <div className="mt-4 grid h-64 place-items-center rounded-md border border-dashed border-border text-sm text-muted-foreground">
            (subject + body)
          </div>
        </div>
        <aside className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <p className="text-sm font-semibold uppercase tracking-widest text-muted-foreground">
            Member context
          </p>
          <p className="mt-3 text-sm text-muted-foreground">
            Last 5 registrations, score components, draft history. Stub.
          </p>
        </aside>
      </div>
    </div>
  );
}
